import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
// import { FaRegHeart, FaBalanceScale } from "react-icons/fa";

const useStyles = makeStyles({
  card: {
    maxWidth: "330px",
    minWidth: "330px",
    borderRadius: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxShadow: "none",

    // "&:hover": {
    //   "& $media": {
    //     height: "155px",
    //   },
    //   "& $HoverDiv": {
    //     height: "50px",
    //   },
    // },
  },
  cardButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    flex: 1,
  },
  media: {
    height: "205px",
    transition:
      "minHeight 0.15s ease-in-out 0s,height 0.15s ease-in-out 0s,maxHeight 0.15s ease-in-out 0s",
  },
  price: {
    fontSize: "24px",
    fontWeight: "600",
    color: "black",
    fontFamily: '"Arial Narrow", sans-serif !important',
    textAlign: "left",
  },
  address: {
    fontSize: "20px",
    fontWeight: "bold",
    fontFamily: '"Arial Narrow", sans-serif !important',
    color: "#777",
    lineHeight: "1.4",
    textAlign: "left",
  },
  courtesy: {
    fontFamily: '"Arial Narrow", sans-serif !important',
    color: "#666",
    fontSize: "16px",
    textAlign: "left",
    fontWeight: "600",
    marginTop: "5px",
  },
  brokerImage: {
    backgroundImage:
      'url("https://d9la9jrhv6fdd.cloudfront.net/mlslogos/151.png")',
    width: "100px",
    height: "21px",
    backgroundSize: "cover",
  },
  CardDetailContainer: {
    display: "flex",
    flexDirection: "row",
  },
  CardDetailFamily: {
    textAlign: "end",
    fontSize: "12px",
    color: "#777",
    marginRight: "5px",
  },
  BedsContainer: {
    width: "100%",
    borderColor: "#d7d7d7",
    borderTop: "1px solid",
    borderRight: "1px solid #d7d7d7",
    padding: "3px 0",
  },
  BathContainer: {
    width: "100%",
    borderColor: "#d7d7d7",
    borderTop: "1px solid",
    borderRight: "1px solid #d7d7d7",
    padding: "3px 0",
  },
  sqftContainer: {
    width: "100%",
    borderColor: "#d7d7d7",
    borderTop: "1px solid",
    padding: "3px 0",
  },
  DetailText: {
    color: "#666",
    fontSize: "15px",
    fontWeight: "400",
    lineHeight: 1.2,
  },
  ValueText: {
    color: "#666",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: 1.2,
    marginBottom: "2px",
  },
  cardContent: {
    flex: 1,
  },
  actionAreaBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    flex: 1,
  },
  HoverDiv: {
    height: "0px",
    display: "flex",
    flexDirection: "row",
    transition: "height 0.15s ease-in-out 0s",
    overflow: "hidden",
  },
  addToFav: {
    width: "100%",
    backgroundColor: "#cc1c1c",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
    "&:hover": {
      "& $bottomText": {
        textDecoration: "underline !important",
      },
    },
  },
  similar: {
    width: "100%",
    backgroundColor: "#c10000",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",

    "&:hover": {
      "& $bottomText": {
        textDecoration: "underline !important",
      },
    },
  },
  bottomText: {
    fontSize: "13px",
    color: "white",
    width: "50%",
  },
});

const MediaCard = (props) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardActionArea
        className={classes.cardButton}
        onClick={() => {
          window.open(props.link);
        }}
      >
        <CardMedia className={classes.media} image={props.imageUrl} title="" />
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom className={classes.price}>
            {props.price}
          </Typography>
          <Typography gutterBottom className={classes.address}>
            {props.address}
          </Typography>
          {props.courtesy ? (
            <>
              <Typography gutterBottom className={classes.courtesy}>
                {props.courtesy.toUpperCase()}
              </Typography>
              <Typography className={classes.brokerImage}></Typography>
            </>
          ) : null}
        </CardContent>
        <Typography
          gutterBottom
          component="p"
          className={classes.CardDetailFamily}
        >
          {props.family.toUpperCase()}
        </Typography>
        <Typography component="p" className={classes.CardDetailContainer}>
          <div className={classes.BedsContainer}>
            <div className={classes.ValueText}>{props.beds}</div>
            <div className={classes.DetailText}>BEDS</div>
          </div>
          <div className={classes.BathContainer}>
            <div className={classes.ValueText}>{props.baths}</div>
            <div className={classes.DetailText}>BATH</div>
          </div>
          <div className={classes.sqftContainer}>
            <div className={classes.ValueText}>{props.sqft}</div>
            <div className={classes.DetailText}>SQFT</div>
          </div>
        </Typography>
      </CardActionArea>
      {/* 
      <Typography component="p" className={classes.HoverDiv}>
        <button className={classes.similar}>
          <div className={classes.icon}>
            <FaBalanceScale color="white" size={18} />
          </div>
          <div className={classes.bottomText}>SIMILAR</div>
        </button>
        <button
          className={classes.addToFav}
          onClick={() => console.log("red button")}
        >
          <div style={{ marginRight: "10px" }}>
            <FaRegHeart color="white" size={18} />
          </div>
          <div className={classes.bottomText}>ADD TO FAVOURITES</div>
        </button>
      </Typography> */}
    </Card>
  );
};

export default React.memo(MediaCard);
